import React from 'react';
import type {BookingSummary, ShortReservation} from '@chekin/core';

export type HomeEnv = {
  reservation?: ShortReservation;
  summary?: BookingSummary;
  isSummaryLoaded: boolean;
  guestStats: {
    totalGuests: number;
    totalRegisteredGuests: number;
    totalFullyRegisteredGuests: number;
  };
  isIVEnabled: boolean;
  navigation: {
    registration: string;
    payments: string;
    remoteAccess: string;
    faq?: string;
  };
  onNavigate?: (path: string, source: string, extra?: Record<string, unknown>) => void;
};

export const HomeEnvContext = React.createContext<HomeEnv>({
  isSummaryLoaded: false,
  guestStats: {totalGuests: 0, totalRegisteredGuests: 0, totalFullyRegisteredGuests: 0},
  isIVEnabled: false,
  navigation: {registration: '/', payments: '/', remoteAccess: '/'},
});

export function useHomeEnv() {
  return React.useContext(HomeEnvContext);
}

export function useHomeNavigate() {
  const {onNavigate} = useHomeEnv();
  return React.useCallback(
    (navigate: (path: string) => void) =>
      (path: string, source: string, extra?: Record<string, unknown>) => {
        onNavigate?.(path, source, extra);
        navigate(path);
      },
    [onNavigate],
  );
}
